export const CAMERA_Z_POS = 25;
export const CAMERA_Y_POS = 10;
export const CAMERA_OFFSET = 15;
export const PATH_LENGTH = 1000;

export const TerrainPhase = {
    RUNNING: 0,
    RUNNING_END: 1,
    SWIMMING: 2,
    SWIMMING_END: 3,
    BIKING: 4,
    BIKING_END: 5
}

export const CharacterPhase = {
    RUNNING: 0,
    SWIMMING: 1,
    BIKING: 2
}